import type { GridColumnVisibilityModel } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';

export function useColumnVisibilityModel(
  resource: string,
  initialModel: GridColumnVisibilityModel = {},
) {
  const localStorageKey = `${resource}.list.columns`;

  const [columnVisibilityModel, setColumnVisibilityModel] = useState<GridColumnVisibilityModel>(
    () => {
      try {
        const prevModel = localStorage.getItem(localStorageKey);

        return prevModel ? (JSON.parse(prevModel) as GridColumnVisibilityModel) : initialModel;
      } catch {
        return initialModel;
      }
    },
  );

  useEffect(() => {
    try {
      localStorage.setItem(localStorageKey, JSON.stringify(columnVisibilityModel));
    } catch {
      // ignore write errors (e.g., quota exceeded)
    }
  }, [columnVisibilityModel, localStorageKey]);

  return [columnVisibilityModel, setColumnVisibilityModel] as const;
}
